
import {
  Mixins, Component, Watch, Prop,
} from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/org';
import { ISetting } from '@/types/set.d';
import bModal from './bModal.vue';
import tableMixin from './tableMixin';


@Component({
  components: {
    Pagination,
    bModal,
  },
})
export default class tData extends Mixins(tableMixin) {
  private visible: boolean = false;

  private title: string = '修改配置';

  private form: any = {};

  private addType: string = '';

  private isShowSelectOpt: boolean = true;

  private showDiffi: boolean = false;

  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/set/normal:add',
    icon: 'plus',
    callback: this.handleAddCon,
    log: {
      name: '机构管理 - 新增',
      component: 'org/mange/components/bModal',
    },
  }];

  handleAddCon() {
    this.title = '添加配置';
    this.visible = true;
    this.form.type = this.type;
    this.isShowSelectOpt = true;
    this.showDiffi = false;
    if (this.type === 'knowledge') this.form.difficulties = this.difficulties;
  }

  /**
   * @author liangyongmou
   * @desc 编辑配置
   * @param { any } row 行数据
   */
  handleUpdateForm(row: any) {
    this.form = row;
    this.form.type = this.type;
    if (this.type === 'knowledge') this.form.difficulties = this.difficulties;
    this.title = '编辑配置';
    this.visible = true;
    this.isShowSelectOpt = false;
    this.showDiffi = true;
  }

  getType(addType: string) {
    this.addType = addType;
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData(this.type);
  }
}
